export default (props = {}) => <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M2.08984 3.24805H18.834" stroke="white" stroke-width="1.56977" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.08984 17.6816H18.834" stroke="white" stroke-width="1.56977" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.08984 10.4648H18.834" stroke="white" stroke-width="1.56977" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
